import React from "react";
import "./about.scss";
import { PiHouseLine } from "react-icons/pi";
import { BsCreditCard } from "react-icons/bs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const about = () => {
  const waabout = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285212538280&text=Halo+Dennys%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20https://agungsedayu-pik2.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const wabrosur = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285212538280&text=Halo+Dennys%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(brosur)%20https://agungsedayu-pik2.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  return (
    <div id="about" className="about">
      <div className="container-about">
        <div className="header-about">
          <div className="judul-about">Pantai Indah Kapuk 2 </div>
          <div className="subjudul-about">Pantai Pasir Putih, Banten</div>
          <div className="sec-about">
            <div className="home-about">
              <div className="icon-home-about">
                <PiHouseLine />
              </div>
              <div className="ket-home">
                <div className="judul-home-about">Tipe Propety</div>
                <div className="subjudul-home-about">
                  Rumah Ready Dan Indent
                </div>
              </div>
              <div className="button-home-about">
                <button className="brosur" onClick={wabrosur}>
                  Brosur
                </button>
              </div>
            </div>
            <div className="pembayaran-about">
              <div className="icon-pembayaran-about">
                <BsCreditCard />
              </div>
              <div className="ket-pembayaran">
                <div className="judul-pembayaran-about">Jenis Pembayaran</div>
                <div className="subjudul-pembayaran-about">
                  Cash dan KPR 100% Approved
                </div>
              </div>
              <div className="button-pembayaran-about">
                <button className="card" onClick={waabout}>
                  <span className="waicon">
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </span>
                  &nbsp; Whatsapp
                </button>
              </div>
            </div>
          </div>
          <div className="about-us">
            <div className="judul-about-us">
              <b>Agung Sedayu Group's</b> Latest Masterpiece in Collaboration
              With <b> The Salim Group</b>
            </div>
            <div className="subjudul-about-us">
              Pantai Indah Kapuk 2 dikembangkan oleh Agung Sedayu Group dan
              Salim Group. Agung Sedayu Group adalah pengembang properti
              terkemuka di Indonesia dengan lebih dari 50 tahun pengalaman.
              Mereka juga mengembangkan Indonesia Design District (IDD), yang
              merupakan pusat gaya hidup terbesar dan paling modern di
              Indonesia. IDD adalah konsep terbaru yang dikembangkan oleh Agung
              Sedayu Group dan Salim Group di kawasan Pantai Indah Kapuk 2.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default about;
